"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchOnList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const layout_1 = require("@chakra-ui/layout");
const menu_1 = require("@chakra-ui/menu");
const system_1 = require("@chakra-ui/system");
const SearchOnList = ({ data, selectedCountryCode, onChange }) => {
    const [selectedItem, setSelectedItem] = (0, react_1.useState)(selectedCountryCode);
    const styles = (0, system_1.useMultiStyleConfig)('FormInputPhoneNumber', {});
    return ((0, jsx_runtime_1.jsx)(menu_1.MenuList, Object.assign({ sx: styles.searchOnListBox, padding: "0", minW: "0", motionProps: { animate: 'none' } }, { children: data.map((item) => {
            return ((0, jsx_runtime_1.jsxs)(menu_1.MenuItem, Object.assign({ onClick: () => {
                    onChange(item);
                    setSelectedItem(item.code);
                }, sx: styles.searchOnListListItem, backgroundColor: item.code === selectedItem ? 'gray.100' : '' }, { children: [(0, jsx_runtime_1.jsx)(layout_1.Text, { children: item.flag }), (0, jsx_runtime_1.jsx)(layout_1.Text, Object.assign({ paddingX: 2 }, { children: item.dialCode })), (0, jsx_runtime_1.jsx)(layout_1.Text, Object.assign({ fontSize: "14px" }, { children: item.name }))] }), item.code));
        }) })));
};
exports.SearchOnList = SearchOnList;
